import Sensors from './sensors'
import '../precision'
import { getToken } from '../../api/service/user'
import { getStorage } from '../helpers'
import { getPageCode } from './utils'

export default abstract class BaseFunc {
  protected landingTime: Date

  protected static visited_product: Array<string> = []

  // eslint-disable-next-line class-methods-use-this
  public getVisitedProductCount(): Number {
    return BaseFunc.visited_product.length
  }

  // eslint-disable-next-line class-methods-use-this
  public resetVisitedProduct(): void {
    BaseFunc.visited_product = []
  }

  private static sensors: Sensors | null

  constructor() {
    this.landingTime = new Date()
    this.scrollTimer = null
    BaseFunc.sensors = null
  }

  private static isLogin(): boolean {
    const token = getToken()
    return token != null
  }

  private static isNew(): boolean {
    return !getStorage('has_order')
  }

  public getSensors(): Sensors {
    if (this != null) {
      if (BaseFunc.sensors != null) {
        BaseFunc.sensors.IsLogin = BaseFunc.isLogin()
        BaseFunc.sensors.IsNew = BaseFunc.isNew()
      } else {
        BaseFunc.sensors = new Sensors(
          BaseFunc.isLogin(),
          BaseFunc.isNew(),
          true,
          false
        )
      }
    }
    return BaseFunc.sensors ?? new Sensors(true, true, true, true)
  }

  public getStayTime(): Number {
    const now = new Date()
    return Number(
      now.getTime().sub(this.landingTime.getTime()).div(1000).toFixed(2)
    )
  }

  protected static getHeader(): HTMLElement {
    return document.getElementsByTagName('header')[0]
  }

  protected static getMain(): HTMLElement {
    return document.getElementsByTagName('main')[0]
  }

  protected static getFooter(): HTMLElement {
    return document.getElementsByTagName('footer')[0]
  }

  protected static getPageCode(): string {
    return getPageCode()
  }

  // eslint-disable-next-line class-methods-use-this
  public getPageCode2(): string {
    return BaseFunc.getPageCode()
  }

  // eslint-disable-next-line class-methods-use-this
  public getPageID2(): string {
    return BaseFunc.getPageID()
  }

  public static getAdminID(id: string): string {
    return window.atob(id).replace(/\D/g, '')
  }

  // eslint-disable-next-line class-methods-use-this
  public getAdminID2(id: string): string {
    return window.atob(id).replace(/\D/g, '')
  }

  public static getPageID(): string {
    let pageID = ''
    switch (this.getPageCode()) {
      case '首页':
        pageID = '首页'
        break
      case '商品列表':
        pageID = this.getAdminID(
          document.getElementById('collection')?.dataset.id ?? ''
        )
        break
      case '商品详情页':
        pageID = document.getElementById('product')?.dataset.spu as string
        break
      default:
        break
    }
    return pageID
  }

  protected static getSpuFromSku(sku: string): string {
    const reg = /.{11,14}\d(?=\D)/g
    const result = reg.exec(sku)
    const spu = result == null ? '' : result[0]
    return spu
  }

  protected static getHeaderHeight(): Number {
    let result = 0
    const active = this.getHeader().getElementsByClassName('active')
    if (active.length > 0) {
      result = active[0].clientHeight
    } else {
      result = this.getHeader().clientHeight
    }
    return result
  }

  public static getCurrentShowing(
    elementArray: HTMLCollectionOf<Element>
  ): Array<Element> {
    const result = new Array<Element>()
    const headerHeight = this.getHeaderHeight()
    const containerHeigh = Number(window.innerHeight).sub(headerHeight)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    for (let i = 0; i < elementArray.length; i += 1) {
      const section = elementArray[i] as HTMLDivElement
      const sectionClient = section.getBoundingClientRect()
      let isV = false
      // console.log('huey-containerHeigh', containerHeigh)
      if (section.clientHeight <= containerHeigh) {
        if (
          /* 上边缘在视区范围内 */
          // section.offsetTop >= scrollTop.add(headerHeight) && // 上边缘离开临界
          sectionClient.top >= 0 &&
          sectionClient.top <= containerHeigh &&
          /* 下边缘在视区范围内 */
          // section.offsetTop.add(section.offsetHeight) <= scrollTop.add(window.innerHeight) // 下边缘露出临界
          sectionClient.top.add(section.clientHeight) >= 0 &&
          sectionClient.top.add(section.clientHeight) <= containerHeigh
        ) {
          isV = true
        }
        /* 上边缘露出 */
      } else if (
        // section.offsetTop <= scrollTop.add(window.innerHeight).sub(100) && // 上边缘露出临界-露出100像素
        sectionClient.top.add(100) < containerHeigh &&
        // section.offsetTop.add(section.offsetHeight) >= scrollTop.add(headerHeight).add(100)
        sectionClient.top.add(section.clientHeight).sub(100) > 0
      ) {
        isV = true
      }
      if (isV) {
        let isH = false
        if (section.offsetWidth <= window.innerWidth) {
          /* 判断水平是否露出 */
          isH =
            sectionClient.left >= 0 && sectionClient.right <= window.innerWidth
        } else {
          /* 判断是否有部分显示于页面 */
          isH =
            sectionClient.left - window.innerWidth < 0 &&
            sectionClient.right > 0
        }
        if (isH) {
          result.push(section)
        }
      }
    }
    return result
  }

  protected scrollTimer: NodeJS.Timeout | null

  protected scrollEndShowing(
    elementArray: HTMLCollectionOf<Element>,
    time: number,
    func: Function
  ): void {
    document.addEventListener('scroll', () => {
      if (this.scrollTimer != null) {
        clearTimeout(this.scrollTimer)
      }
      // eslint-disable-next-line no-param-reassign
      this.scrollTimer = setTimeout(() => {
        const currentShowing = BaseFunc.getCurrentShowing(elementArray)
        func(currentShowing)
      }, time)
    })
  }

  private static createLocalView(name: string): LocalView {
    const saveLocalList = {
      time: new Date().getTime(),
      datas: [] as string[],
    } as LocalView
    localStorage.setItem(name, JSON.stringify(saveLocalList))
    return saveLocalList
  }

  private static getLocalView(name: string): LocalView {
    const localViewStr = localStorage.getItem(name)
    let localView =
      localViewStr == null
        ? this.createLocalView(name)
        : (JSON.parse(localViewStr) as LocalView)
    if (
      localView.time + 2 * 1000 * 60 * 60 < new Date().getTime() ||
      localView.datas.length >= 10000
    ) {
      localView = this.createLocalView(name)
    }
    return localView
  }

  protected static saveLocalView(name: string, id: string): boolean {
    let canSave = false
    const localView = this.getLocalView(name)
    if (!localView.datas.includes(id)) {
      canSave = true
      localView.datas.push(id)
      localStorage.setItem(name, JSON.stringify(localView))
    }
    return canSave
  }
}

interface LocalView {
  time: number
  datas: string[]
}
